import { Box } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

import { IUnitCardModel } from '../../../../../../service/unit/interface/IUnitCardModel';
import { IPassingListPageDomain } from '../../store/IPassingListPageDomain';
import { GroupCardComponentHeader } from './GroupCardComponentHeader';
import { GroupCardComponentList } from './GroupCardComponentList';
import { Colors } from '../../../../../design/color/Colors';

interface GroupCardComponentProperties {
  groupName: string;
  passingPercent: number;
  importantUnitList: IUnitCardModel[];
  unimportantUnitList: IUnitCardModel[];
  domain: IPassingListPageDomain;
}

export const GroupCardComponent = observer(
  ({ groupName, passingPercent, importantUnitList, unimportantUnitList, domain }: GroupCardComponentProperties) => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '16px',
          gap: '16px',
          borderRadius: '16px',
          background: Colors.bgElevated,
        }}
      >
        <GroupCardComponentHeader
          groupName={groupName}
          passingPercent={passingPercent}
          count={importantUnitList.length + unimportantUnitList.length}
        />
        <GroupCardComponentList title={'Обязательные'} unitList={importantUnitList} domain={domain} />
        <GroupCardComponentList title={'Дополнительные'} unitList={unimportantUnitList} domain={domain} />
      </Box>
    );
  },
);
